// Shared helpers for the student edit dialogs' Class dropdown.
export const classOptionLabel = (c) => {
    const yr = (c.min_birth_year && c.max_birth_year)
        ? (c.min_birth_year === c.max_birth_year ? `${c.min_birth_year}` : `${c.max_birth_year}:${c.min_birth_year}`)
        : '';
    const name = c.arabic_name || c.name || c.english_name || '(unnamed)';
    const teacher = c.teacher_name || 'Unassigned';
    const gender = c.gender_mix ? `(${c.gender_mix})` : '';
    return [name, teacher, yr, gender].filter(Boolean).join(' - ');
};

const englishName = (c) => (c.english_name || c.name || c.arabic_name || '').toLowerCase();

export const sortClassesByEnglishName = (list) =>
    [...(list || [])].sort((a, b) => englishName(a).localeCompare(englishName(b)) || (a.arabic_name || '').localeCompare(b.arabic_name || ''));
